import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  toggle(event) {
    const profileId = event.currentTarget.dataset.profileId
    const content = this.element.querySelector(`[data-profile-details-target="content"][data-profile-id="${profileId}"]`)
    const button = event.currentTarget
    const icon = button.querySelector('i')
    
    if (content) {
      if (content.classList.contains('hidden')) {
        // Zeige Details
        content.classList.remove('hidden')
        icon.classList.remove('fa-chevron-down')
        icon.classList.add('fa-chevron-up')
        button.querySelector('span').textContent = 'Weniger'
      } else {
        // Verstecke Details
        content.classList.add('hidden')
        icon.classList.remove('fa-chevron-up')
        icon.classList.add('fa-chevron-down')
        button.querySelector('span').textContent = 'Details'
      }
    }
  }
}
